import { ElementRef, Renderer2, SimpleChanges } from '@angular/core';
import { detailedDiff } from '@core/shared/utils';
import * as i0 from "@angular/core";
export let CustomAttributesDirective = /*#__PURE__*/(() => {
  class CustomAttributesDirective {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
    }
    ngOnChanges(changes) {
      if (changes.customAttributes) {
        const differences = detailedDiff(changes.customAttributes.currentValue, changes.customAttributes.previousValue || {});
        // console.log('attr directive changed',changes.customAttributes, this.customAttributes, differences)
        Object.keys(differences.deleted || {}).forEach(attrName => {
          this.renderer.removeAttribute(this.el.nativeElement, attrName);
        });
        const additions = {
          ...differences.added,
          ...differences.updated
        };
        Object.keys(additions || {}).forEach(attrName => {
          this.renderer.setAttribute(this.el.nativeElement, attrName, additions[attrName]);
        });
      }
    }
    static {
      this.ɵfac = function CustomAttributesDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomAttributesDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: CustomAttributesDirective,
        selectors: [["", "customAttributes", ""]],
        inputs: {
          customAttributes: "customAttributes"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return CustomAttributesDirective;
})();